export default __webpack_public_path__ + "static/media/photo--sm--dinner.3004163b.jpg";